import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { observer } from "mobx-react";

import { Button } from "@components/buttons";
import {
	PartnerRegistrationBirthName,
	PartnerRegistrationTitle,
} from "@features/membership/desktop/registration-types/partner-registration";
import {
	RegistrationCountry,
	RegistrationDOB,
	RegistrationEmail,
	RegistrationFirstName,
	RegistrationLastName,
	RegistrationPassword,
	RegistrationPhone,
	RegistrationState,
	RegistrationUsername,
} from "@features/membership/desktop/registration-types/registration";
import { useRootAppStore } from "@hooks";
import { usePartnerRegistrationStore } from "@state/context/membership/registration-types/PartnerRegistrationStoreContext";
import { getCurrentCulture } from "@utils";

export const PartnerRegistrationAccountDetails = observer(
	function PartnerRegistrationAccountDetails() {
		const { t } = useTranslation(["registration", "password-change"]);
		const { trigger } = useFormContext();

		const { isIpRestricted } = useRootAppStore();

		const {
			titleData,
			countryData,
			countryRegionsData,
			checkUserNameAvailability,
			checkIsEmailAvailable,
			checkPasswordSimilarity,
			setCurrentStep,
			toggleStepSwitchFlag,
			isSwitchingSteps,
		} = usePartnerRegistrationStore();

		return (
			<>
				<div className="card--onboarding__content">
					<PartnerRegistrationTitle titleData={titleData} />

					<div className="form__field form--grid">
						<div className="form--grid__row row">
							<div className="form--grid__col col col-sml-6">
								<RegistrationFirstName labelClassName="label--strong" />
							</div>
							<div className="form--grid__col col col-sml-6">
								<RegistrationLastName labelClassName="label--strong" />
							</div>
						</div>
					</div>

					<PartnerRegistrationBirthName labelClassName="label--strong" />

					<RegistrationDOB
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationCountry
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationState
						countryRegionsData={countryRegionsData}
						labelClassName="label--strong"
					/>

					<RegistrationUsername
						checkUserNameAvailability={checkUserNameAvailability}
						labelClassName="label--strong"
					/>

					<RegistrationPassword
						checkPasswordSimilarity={checkPasswordSimilarity}
						labelClassName="label--strong"
					/>

					<RegistrationEmail
						checkIsEmailAvailable={checkIsEmailAvailable}
						labelClassName="label--strong"
					/>

					<RegistrationPhone
						labelClassName="label--strong"
						required
					/>
				</div>

				<Button
					btnText={t("COMMON.NEXT_BUTTON")}
					atClassName="PartnerRegistrationAccountDetails"
					className="btn--base btn--block btn--accent"
					iconRight
					iconClassName="u-icon--tny u-icon--arrow-right u-color--accent--text"
					type="button"
					isLoading={isSwitchingSteps}
					disabled={isIpRestricted}
					onClick={async () => {
						toggleStepSwitchFlag(true);
						const isValid = await trigger();

						if (isValid) {
							setCurrentStep(2, true);
						}
						toggleStepSwitchFlag(false);
					}}
				/>

				<div className="card--onboarding__footer u-type--sml u-color--text--secondary">
					{t("EXISTING_ACCOUNT")}
					<Link
						to={`/${getCurrentCulture()}/auth/login`}
						className="u-anchor u-anchor--primary u-mar--left--xtny"
					>
						{t("COMMON.LOGIN_BUTTON")}
					</Link>
				</div>
			</>
		);
	}
);
